import { runInAction } from 'mobx';
import { getFilterByIdAndType } from '../selectors/get-filter-by-id-and-type';
import { setFilterValue as setFilterValueUtility } from '../utils/set-filter-value';
export const setFilterValue = (props) => {
    const { id, type, key, value, multiselect, selected } = props;
    const filter = getFilterByIdAndType(id, type);
    if (!filter)
        throw new Error(`No ${type} filter found with the given id: ${id}.`);
    runInAction(() => {
        setFilterValueUtility({ filter, value, multiselect, selected, key });
    });
};
